<template>
  <b-modal
    id="modal-scrollable"
    v-model="$store.state.someVariables.showModalRecibo"
    scrollable
    no-close-on-backdrop
    size="xl"
    title="Detalle Recibo"
    cancel-variant="outline-secondary"
    @hidden="cerrarModal"
  >
    <b-row class="p-1">
      <b-col md="6">
        <b-tabs>
          <b-tab :title="partido.local" @click="changeTab('local')">
            <content-recibo
              :listMultasRecibo="listMultas"
              :bloquearRecibo="bloquearElRecibo"
              @ponerEnDetalle="putInDetalle($event)"
              :hasRecibo="hasRecibo"
              :loading="loadingRecibo"
              :totalPendiente="totalPendiente"
            ></content-recibo>
          </b-tab>
          <b-tab :title="partido.visita" @click="changeTab('visita')">
            <content-recibo
              :listMultasRecibo="listMultas"
              :bloquearRecibo="bloquearElRecibo"
              @ponerEnDetalle="putInDetalle($event)"
              :hasRecibo="hasRecibo"
              :loading="loadingRecibo"
              :totalPendiente="totalPendiente"
            ></content-recibo>
          </b-tab>
        </b-tabs>
      </b-col>
      <b-col md="6">
        <content-detalle
          :listDetalle="listDetalle"
          :listFijos="listFijos"
          :bloquearRecibo="bloquearElRecibo"
          @ponerEnPendientes="putInMultas"
          @marcarPagado="pagarOReset"
          :hasRecibo="hasRecibo"
          :isReciboPagado="isReciboPagado"
          :arbitraje="partido.arbitraje"
          :delVocal="partido.del_vocal"
          :loading="loadingRecibo"
          :totalRecibo="totalRecibo"
          :totalFijo="totalFijos"
          :total="totalPagarPartido"
          :dataReciboCabecera="dataReciboCabecera"
        ></content-detalle>
      </b-col>
    </b-row>
    <template #modal-footer>
      <div style="justify-content:start; width:100%">
        <b-row>
          <b-col
            v-if="
              bloquearElRecibo != 's' &&
                (USER().rol === ROLES.SUPER ||
                  USER().rol === ROLES.ADMIN ||
                  USER().rol === ROLES.TESORERIA)
            "
            md="12"
            class="d-flex justify-content-end"
          >
            <b-button
              v-if="!showLoading"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              class="float-right mr-1"
              size="sm"
              @click="onlyClose"
            >
              Cancelar
            </b-button>
            <b-button
              v-if="!showLoading"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="float-right"
              size="sm"
              @click="actionBoton"
            >
              <span v-if="hasRecibo">Elimininar</span>
              <span v-else>Guardar</span>
            </b-button>
            <b-button
              v-if="showLoading"
              variant="primary"
              size="sm"
              disabled
              class="mr-1"
            >
              <b-spinner small /> </b-button
          ></b-col>
        </b-row>
      </div>
    </template>
  </b-modal>
</template>
<script>
import {
  BTabs,
  BTab,
  BRow,
  BCol,
  // BBadge,
  BButton,
  BSpinner,
  //   xxx ,
} from 'bootstrap-vue'
import { ref, computed } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import ContentRecibo from './ContentRecibo.vue'
import ContentDetalle from './ContentDetalle.vue'
import {
  URL,
  USER,
  ROLES,
  // xxx,
} from '../../utils/variables'
import apiCall from '../../utils/apiCall'

export default {
  components: {
    BTabs,
    BTab,
    ContentRecibo,
    BRow,
    BCol,
    ContentDetalle,
    // BBadge,
    BButton,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  props: {
    partido: Object,
    listMultas: Array,
    listDetalle: Array,
    listFijos: Array,
    bloquearElRecibo: String,
    hasRecibo: Boolean,
    isReciboPagado: Boolean,
    loadingRecibo: Boolean,
    dataReciboCabecera: Object,
  },
  setup(props, { emit }) {
    const { postApi } = apiCall()
    const idEquipo = ref(props.partido.id_local)
    const tipo = ref('local')
    const showLoading = ref(false)
    // const bloquearRecibo = computed(() => {
    //   let bloquear = ''
    //   if (tipo === 'local') {
    //     console.log('local')
    //     bloquear = props.partido.bloquear_local
    //   } else {
    //     bloquear = props.partido.bloquear_visita
    //     console.log('visita')
    //   }
    //   return bloquear
    // })
    // props.partido.bloquear_local)
    // console.log(bloquearRecibo)
    // let bloquearRecibo = computed({
    //   get: () => props.partido.bloquear_local,
    //   set: value => {
    //     props.partido.bloquear_local = value
    //   },
    // })
    // const dataRecibo = ref({
    //   fechaEmision: props.partido.fecha_emision_local,
    //   numRecibo: props.partido.id_recibo_local,
    // })
    // const listDetalle = ref([])

    function defineIdEquipo(type) {
      if (type === 'local') {
        tipo.value = 'local'
        idEquipo.value = props.partido.id_local
        // bloquearRecibo.value = props.partido.bloquear_local
        // dataRecibo.value = {
        //   fechaEmision: props.partido.fecha_emision_local,
        //   numRecibo: props.partido.id_recibo_local,
        // }
      } else {
        tipo.value = 'visita'
        idEquipo.value = props.partido.id_visita
        // bloquearRecibo.value = props.partido.bloquear_visita
        // dataRecibo.value = {
        //   fechaEmision: props.partido.fecha_emision_visita,
        //   numRecibo: props.partido.id_recibo_visita,
        // }
      }
    }
    function changeTab(type) {
      const data = {
        partido: props.partido,
        tipo: type,
      }
      defineIdEquipo(type)
      // props.bloquearElRecibo = 'n'
      emit('changeTab', data)
    }
    function cerrarModal() {
      // console.log('cerrando')
      // props.listDetalle = []
      // bloquearRecibo.value = null
      idEquipo.value = null
      showLoading.value = false
      tipo.value = 'local'
      emit('cerrarModal')
    }
    function onlyClose() {
      store.commit('someVariables/UPDATE_SHOW_RECIBO', false)
    }
    function putInDetalle(item) {
      props.listDetalle.push(item)
    }
    function putInMultas(item) {
      props.listMultas.unshift(item)
    }
    const totalPendiente = computed(() => {
      let total = 0
      props.listMultas.forEach(element => {
        total += Number(element.v_total)
      })
      return total.toFixed(2)
    })
    const totalRecibo = computed(() => {
      let total = 0
      props.listDetalle.forEach(element => {
        total += Number(element.v_total)
      })
      return total.toFixed(2)
    })
    const totalFijos = computed(() => {
      let total = 0
      props.listFijos.forEach(element => {
        total += Number(element.valor)
      })
      // console.log(total)
      return total.toFixed(2)
    })
    const totalPagarPartido = computed(
      // eslint-disable-next-line
      () =>
        // eslint-disable-next-line
        (Number(totalRecibo.value) + Number(totalFijos))
          // eslint-disable-next-line
          .toFixed(2),
    )

    async function saveRecibo() {
      showLoading.value = true
      let idRecibo = null
      const path = 'ApiMultas/insertRecibo'
      // console.log(tipo.value)
      if (tipo.value === 'local') {
        idEquipo.value = props.partido.id_local
        idRecibo = props.partido.id_recibo_local
      } else {
        idEquipo.value = props.partido.id_visita
        idRecibo = props.partido.id_recibo_visita
      }
      const data = {
        id_partido: props.partido.id_partido,
        id_equipo: idEquipo.value,
        multas: props.listDetalle,
        id_recibo: idRecibo,
        id_usuario: USER().id_usuario,
        // multas_reset: props.listMultas,
        // arbitraje: props.partido.arbitraje,
        localVisita: tipo.value,
        fijos: props.listFijos,
      }
      // console.log(data)
      const response = await postApi(URL, path, data)
      if (response.flag === 'si') {
        if (tipo.value === 'local') {
          props.partido.id_recibo_local = response.id_recibo
          props.partido.total_local = response.total
          data.id_recibo = response.id_recibo
        } else {
          props.partido.id_recibo_visita = response.id_recibo
          props.partido.total_visita = response.total
          data.id_recibo = response.id_recibo
        }

        // props.hasRecibo = true
        // store.commit('someVariables/UPDATE_SHOW_RECIBO', false)

        // emit('reciboGenerado', response)
        emit('reciboGenerado', {
          tipo: tipo.value,
          info: data,
          partido: props.partido,
        })
        // props.bloquearElRecibo = 's'
      } else {
        emit('falloRecibo', {
          mensaje: response.mensaje,
        })
        // props.bloquearElRecibo = 'n'
      }
      showLoading.value = false
    }
    async function deleteRecibo() {
      // console.log(props.listDetalle)
      let idRecibo
      let idEquipoSend
      let equipoSend
      if (tipo.value === 'local') {
        idRecibo = props.partido.id_recibo_local
        idEquipoSend = props.partido.id_local
        equipoSend = props.partido.local
      } else {
        idRecibo = props.partido.id_recibo_visita
        idEquipoSend = props.partido.id_visita
        equipoSend = props.partido.visita
      }
      // console.log('delete')
      // showLoading.value = true
      const path = 'ApiMultas/deleteRecibo'
      const data = {
        id_recibo: idRecibo,
        multas_reset: props.listDetalle,
        localVisita: tipo.value,
        id_partido: props.partido.id_partido,
        id_equipo: idEquipoSend,
        id_user: USER().id_usuario,
        idTorneo:
          store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
        movimiento: `Elimina recibo del equipo ${equipoSend} del partido ${props.partido.local} vs ${props.partido.visita} categoria ${props.partido.name_disciplina} ${props.partido.categoria} del dia ${props.partido.fecha}`,
      }
      // console.log(data)
      const response = await postApi(URL, path, data)
      if (response.flag === 'si') {
        if (tipo.value === 'local') {
          props.partido.id_recibo_local = response.id_recibo
          props.partido.total_local = response.total
        } else {
          props.partido.id_recibo_visita = response.id_recibo
          props.partido.total_visita = response.total
        }
        // props.hasRecibo = false
        // store.commit('someVariables/UPDATE_SxHOW_RECIBO', false)
        props.listDetalle.forEach(element => {
          props.listMultas.unshift(element)
        })
        emit('reciboEliminado', {
          tipo: tipo.value,
          info: data,
          partido: props.partido,
        })

        // emit('reciboGenerado')
        // props.bloquearElRecibo = 's'
      }
    }

    function actionBoton() {
      if (props.hasRecibo) {
        deleteRecibo()
      } else {
        saveRecibo()
      }
    }

    async function marcarPagado() {
      // console.log('marcarPagado')
      const path = 'ApiMultas/updateDetalleMulta'
      let idRecibo = null
      if (tipo.value === 'local') {
        idEquipo.value = props.partido.id_local
        idRecibo = props.partido.id_recibo_local
      } else {
        idEquipo.value = props.partido.id_visita
        idRecibo = props.partido.id_recibo_visita
      }
      // const data = {
      //   id_partido: props.partido.id_partido,
      //   id_equipo: idEquipo.value,
      //   multas: props.listDetalle,
      //   id_recibo: idRecibo,
      //   id_usuario: USER().id_usuario,
      //   // multas_reset: props.listMultas,
      //   // arbitraje: props.partido.arbitraje,
      //   localVisita: tipo.value,
      //   fijos: props.listFijos,
      // }

      const data = {
        multas: props.listDetalle,
        id_recibo: idRecibo,
        id_equipo: idEquipo.value,
        id_usuario: USER().id_usuario,
      }
      // console.log(data)
      const response = await postApi(URL, path, data)
      if (response.flag === 'si') {
        // props.isReciboPagado = true
        // props.bloquearElRecibo = 's'
        // emit('pagadoCorrectamente', { tipo: tipo.value, accion: true })
        emit('pagadoCorrectamente', {
          tipo: tipo.value,
          info: data,
          partido: props.partido,
          accion: true,
        })
      }
      // console.log(response)
    }
    async function resetPagado() {
      // console.log('resetPagado')
      // console.log(tipo.value)
      const path = 'ApiMultas/resetPagado'
      let idRecibo = null
      if (tipo.value === 'local') {
        idRecibo = props.partido.id_recibo_local
        idEquipo.value = props.partido.id_local
      } else {
        idRecibo = props.partido.id_recibo_visita
        idEquipo.value = props.partido.id_visita
      }
      const data = {
        multas: props.listDetalle,
        id_recibo: idRecibo,
        id_equipo: idEquipo.value,
        movimiento: `Quita status pagado del recibo #${idRecibo} partido ${props.partido.local} vs ${props.partido.visita} categoria ${props.partido.name_disciplina} ${props.partido.categoria} del dia ${props.partido.fecha}`,
        id_user: USER().id_usuario,
        idTorneo:
          store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
      }
      // console.log(data)
      const response = await postApi(URL, path, data)
      if (response.flag === 'si') {
        // console.log(props.listDetalle)
        // props.isReciboPagado = true
        // props.bloquearElRecibo = 's'
        // emit('pagadoCorrectamente', { tipo: tipo.value, accion: false })
        emit('pagadoCorrectamente', {
          tipo: tipo.value,
          info: data,
          partido: props.partido,
          accion: false,
        })
      }
      // console.log(response)
    }
    function pagarOReset(valor) {
      // console.log(valor)
      if (valor) {
        marcarPagado()
      } else {
        resetPagado()
      }
    }
    // const { getApi } = apiCall()
    // async function getMultasCompletas() {
    //   // listCanchas.value = []
    //   const path = 'ApiMultas/getMultasCompleto'
    //   const data = await getApi(URL, path)
    //   listCanchas.value = toArrayCanchas(data.data)
    // }
    return {
      putInDetalle,
      // listDetalle,
      putInMultas,
      totalPendiente,
      totalRecibo,
      saveRecibo,
      changeTab,
      cerrarModal,
      marcarPagado,
      showLoading,
      actionBoton,
      USER,
      ROLES,
      onlyClose,
      totalPagarPartido,
      resetPagado,
      pagarOReset,
      totalFijos,
      // bloquearRecibo,
      // dataRecibo,
      // getMultasCompletas,
    }
  },
}
</script>
<style>
.total {
  font-size: 14px !important;
}
</style>
